/* Papeterie Montparnasse — Sticky Add to Cart (DEV, additif & réversible).
   NE cree PAS de seconde logique d'achat : la barre pilote le VRAI bouton
   "Ajouter au panier" du formulaire produit principal. Prix / disponibilite /
   variante sont miroir de la fiche. Robuste aux re-rendus de <product-rerender>
   (on re-requete le bloc d'achat a chaque verification). Fiche produit uniquement. */
(function () {
  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }
  function txt(el) { return el ? (el.textContent || '').replace(/\s+/g, ' ').trim() : ''; }

  function mainInfo() {
    var infos = document.querySelectorAll('.product-info');
    for (var i = 0; i < infos.length; i++) {
      if (infos[i].querySelector('h1.product-info__title')) return infos[i];
    }
    return null;
  }
  function buyEl() {
    var info = mainInfo();
    if (!info) return null;
    return info.querySelector('.product-info__buy-buttons') ||
           info.querySelector('[data-block-type="buy-buttons"]') ||
           info.querySelector('buy-buttons');
  }
  function realBtn() {
    var b = buyEl();
    if (!b) return null;
    return b.querySelector('button[type="submit"]') || b.querySelector('button');
  }
  function priceText() {
    var info = mainInfo();
    var pe = info && info.querySelector('.product-info__price');
    if (!pe) return '';
    var node = pe.querySelector('sale-price') || pe.querySelector('.price-list') || pe;
    var c = node.cloneNode(true);
    c.querySelectorAll('.sr-only, .visually-hidden, [class*="sr-only"]').forEach(function (x) { x.remove(); });
    return txt(c);
  }
  function variantSummary() {
    var info = mainInfo();
    var vp = info && info.querySelector('.product-info__variant-picker');
    if (!vp) return '';
    var parts = [], checked = vp.querySelectorAll('input:checked');
    for (var i = 0; i < checked.length; i++) {
      var inp = checked[i], lbl = '';
      if (inp.id) { var l = vp.querySelector('label[for="' + inp.id + '"]'); if (l) lbl = txt(l); }
      if (!lbl) lbl = inp.getAttribute('value') || '';
      lbl = lbl.replace(/\s+/g, ' ').trim();
      if (lbl) parts.push(lbl);
    }
    return parts.join(' · ');
  }

  ready(function () {
    if (!mainInfo()) return;

    var bar = document.createElement('div');
    bar.className = 'pm-satc';
    bar.setAttribute('aria-hidden', 'true');
    var img = document.querySelector('.product-gallery__media img') || document.querySelector('.product-gallery img');
    bar.innerHTML =
      '<div class="pm-satc__in">' +
        '<div class="pm-satc__media">' + (img ? '<img alt="" src="' + (img.currentSrc || img.src) + '">' : '') + '</div>' +
        '<div class="pm-satc__txt"><span class="pm-satc__title"></span><span class="pm-satc__variant"></span></div>' +
        '<span class="pm-satc__price"></span>' +
        '<button type="button" class="pm-satc__btn">Ajouter au panier</button>' +
      '</div>';
    document.body.appendChild(bar);

    var elTitle = bar.querySelector('.pm-satc__title');
    var elVariant = bar.querySelector('.pm-satc__variant');
    var elPrice = bar.querySelector('.pm-satc__price');
    var elBtn = bar.querySelector('.pm-satc__btn');
    var elImg = bar.querySelector('.pm-satc__media img');

    elBtn.addEventListener('click', function () {
      var b = realBtn();
      if (b && !b.disabled) b.click();
    });

    function sync() {
      elTitle.textContent = txt(mainInfo() && mainInfo().querySelector('.product-info__title'));
      var p = priceText(); if (p) elPrice.textContent = p;
      var vs = variantSummary();
      elVariant.textContent = vs; elVariant.style.display = vs ? '' : 'none';
      var b = realBtn();
      if (b) {
        var dis = b.disabled || b.getAttribute('aria-disabled') === 'true';
        elBtn.disabled = dis; elBtn.classList.toggle('is-disabled', !!dis);
        var t = txt(b); if (t) elBtn.textContent = t;
      }
      var cur = document.querySelector('.product-gallery__media img');
      if (cur && elImg && (cur.currentSrc || cur.src)) elImg.src = cur.currentSrc || cur.src;
    }

    var shown = null;
    function setShown(on) {
      if (on === shown) return; shown = on;
      bar.classList.toggle('is-shown', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
    }
    function check() {
      var b = buyEl();
      if (!b) { setShown(false); return; }
      var r = b.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      // Affiche quand le bloc d'achat est entierement hors de l'ecran (au-dessus ou en dessous).
      setShown(r.bottom < 8 || r.top > vh - 8);
    }
    var ticking = false;
    function onScroll() {
      if (ticking) return; ticking = true;
      requestAnimationFrame(function () { check(); ticking = false; });
    }

    sync(); check();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { onScroll(); sync(); });
    document.addEventListener('change', function (e) { if (mainInfo() && mainInfo().contains(e.target)) sync(); });
    document.addEventListener('variant:change', sync);
    document.addEventListener('shopify:section:load', function () { sync(); check(); });
    // Re-sync periodique leger le temps que les web-components montent / re-render.
    var n = 0, iv = setInterval(function () { sync(); if (++n > 8) clearInterval(iv); }, 500);
  });
})();
